import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Slider from "react-slick";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";

const Program = () => {

  const listProgram = [
    { name:"Bachelor of Business", desc:"Belajar manajemen, marketing, keuangan, skill dasar yang dipakai hampir semua industri.", img:"assets/images/program1.webp", degree:"Sarjana (S1)", tuition:"AUD $19,600 – $20,000 / tahun" },
    { name:"Bachelor of Information Technology", desc:"Cocok kalau kamu mau masuk dunia IT, coding, dan teknologi yang lagi nge-boom.", img:"assets/images/program2.webp", degree:"Sarjana (S1)", tuition:"AUD $22,600 / tahun" },
    { name:"Bachelor of Accounting", desc:"Skill finance & accounting itu selalu dibutuhkan di perusahaan besar.", img:"assets/images/program3.webp", degree:"Sarjana (S1)", tuition:"AUD $18,320 / tahun" },
    { name:"Diploma & Certificate (VET)", desc:"Pilihan cepat skill up & siap kerja dalam 1 – 2 tahun.", img:"assets/images/program4.webp", degree:"Sarjana (S1)", tuition:"AUD $16,400 – $34,800 / tahun" },
  ]

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        <FaChevronRight size={24} />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        <FaChevronLeft size={24} />
      </div>
    );
  };

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,     
    responsive: [   
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },        
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },            
    ],    
  };

  return (
    <>
      <section className="section" id="program">
        <Container>
          <Row className="">
            <Col className="">
              <div className="slide-wrapper">
                <h1 className="mb-3"><b>Program Studi Unggulan</b></h1>
                  <Slider {...settings}>
                    {listProgram.map((item, id) =>(
                      <Card key={id} className=''>
                        <img
                          alt={item.name}
                          src={item.img}
                          className="img-fluid"
                        />
                        <CardBody>
                          <div className="row">
                            <div className="col-1">
                            <BsFillMortarboardFill color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.name}</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-1">
                            <AiFillDollarCircle color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.tuition}</p>
                            </div>
                          </div>     
                          <div className="mt-3">{item.desc}</div>                 
                        </CardBody>
                      </Card>
                    ))}
                  </Slider>
                <p className="note">*Catatan: biaya ini belum termasuk OSHC (asuransi kesehatan), buku, dan living cost.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Program;